import PageContentWrapper from './PageContentWrapper';

export default PageContentWrapper;
